import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col"
};
const _hoisted_3 = {
  class: "flex flex-row"
};
const _hoisted_4 = {
  class: "self-center px-2"
};
const _hoisted_5 = {
  class: "flex flex-row"
};
const _hoisted_6 = {
  class: "self-center px-2"
};
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row"
};
const _hoisted_8 = {
  class: "self-center px-2"
};
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row"
};
const _hoisted_10 = {
  class: "self-center px-2"
};
const _hoisted_11 = {
  key: 2,
  class: "flex flex-row"
};
const _hoisted_12 = {
  class: "self-center px-2"
};
const _hoisted_13 = {
  key: 3,
  class: "flex flex-row"
};
const _hoisted_14 = {
  class: "self-center px-2"
};
import { computed } from 'vue';
export default {
  __name: 'AllocationShareBar',
  props: {
    form: {
      type: Object,
      required: true
    },
    calculateTotalAutimaticallyError: {
      type: Boolean,
      required: true
    }
  },
  setup(__props) {
    _useCssVars(_ctx => ({
      "v30e1764a": d1.value,
      "v30e17648": d2.value,
      "v30e17646": d3.value,
      "v30e17644": d4.value
    }));
    const props = __props;
    const d1 = computed(() => {
      return `${3 * props.form.originatingContribution}px`;
    });
    const d2 = computed(() => {
      return `${3 * props.form.responsibleContribution}px`;
    });
    const d3 = computed(() => {
      return `${3 * props.form.originatingContributionFirm}px`;
    });
    const d4 = computed(() => {
      return `${3 * props.form.workingContribution}px`;
    });
    return (_ctx, _cache) => {
      return __props.calculateTotalAutimaticallyError ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: "/img/ajax-loader.gif"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "bg-blue-500 d1 rounded-lg"
      }, [_createElementVNode("div", {
        class: "px-1"
      })], -1)), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.form.originatingContribution) + " %", 1)]), _createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "bg-yellow-600 d2 rounded-lg"
      }, [_createElementVNode("div", {
        class: "px-1"
      })], -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.form.responsibleContribution) + " %", 1)]), !__props.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "bg-yellow-400 d3 rounded-lg"
      }, [_createElementVNode("div", {
        class: "px-1"
      })], -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(__props.form.originatingContributionFirm) + " % ", 1)])) : _createCommentVNode("", true), __props.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "bg-blue-900 d4 rounded-lg"
      }, [_createElementVNode("div", {
        class: "px-1"
      })], -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(__props.form.workingContribution) + " %", 1)])) : _createCommentVNode("", true), !__props.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "bg-blue-900 d4 rounded-lg"
      }, [_createElementVNode("div", {
        class: "px-1"
      })], -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(__props.form.workingContribution) + " %", 1)])) : _createCommentVNode("", true), __props.form.useWorkingPercentage ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "bg-yellow-400 d3 rounded-lg"
      }, [_createElementVNode("div", {
        class: "px-1"
      })], -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(__props.form.originatingContributionFirm) + " % ", 1)])) : _createCommentVNode("", true)]));
    };
  }
};